module.exports = __webpack_public_path__ + "static/media/filter_icon.b550ab41.jpg";